module.exports = __webpack_public_path__ + "static/media/kikkoman-icon.8e379861.png";